import { downgradeComponent } from "@angular/upgrade/static";
import { UserRole } from "@services/accountFeature.service";
import { AuthorizationService } from "@services/authorization.service";
import { RouteConfigHelperProvider } from "@services/routeConfigHelper.provider";
import { StateProvider } from "@uirouter/angularjs";
import * as angular from "angular";
import { AlertDetailComponent } from "src/app/main/modules/alerts/components/alert-detail/alert-detail.component";
import { AxleWeightAlertDetailService } from "src/app/main/modules/alerts/components/alert-detail/axle-weight-alert-detail/axle-weight-alert-detail.service";
import { GeofenceAlertDetailComponent } from "src/app/main/modules/alerts/components/alert-detail/geofence-alert-detail/geofence-alert-detail.component";
import { GeofenceAlertDetailService } from "src/app/main/modules/alerts/components/alert-detail/geofence-alert-detail/geofence-alert-detail.service";
import { InputAlertDetailService } from "src/app/main/modules/alerts/components/alert-detail/input-alert-detail/input-alert-detail.service";
import { PowerLossAlertDetailService } from "src/app/main/modules/alerts/components/alert-detail/power-loss-alert-detail/power-loss-alert-detail.service";
import { TemperatureAlertDetailComponent } from "src/app/main/modules/alerts/components/alert-detail/temperature-alert-detail/temperature-alert-detail.component";
import { TollAlertDetailService } from "src/app/main/modules/alerts/components/alert-detail/toll-alert-detail/toll-alert-detail.service";
import { TyreRecordAlertDetailService } from "src/app/main/modules/alerts/components/alert-detail/tyre-record-alert-detail/tyre-record-detail.service";
import { VehicleDiagnosticAlertDetailService } from "src/app/main/modules/alerts/components/alert-detail/vehicle-diagnostic-detail/vehicle-diagnostic-detail.service";
import { VideoAlertDetailService } from "src/app/main/modules/alerts/components/alert-detail/video-alert-detail/video-alert-detail.service";
import { AlertReviewDialogComponent } from "src/app/main/modules/alerts/components/alert-review-dialog/alert-review-dialog.component";
import { AlertReviewComplianceComponent } from "src/app/main/modules/alerts/components/alertReviewCompliance/alertReviewCompliance.component";
import { IncidentDetailComponent } from "src/app/main/modules/alerts/components/incidentView/incidentDetail.component";
import { ResolutionCodeEditorComponent } from "src/app/main/modules/alerts/components/resolution-code-editor/resolution-code-editor.component";
import { AlertReviewService } from "src/app/main/modules/alerts/_services/alert-review.service";
import { AlertsNavigationModule } from "./alerts.navigation";
import { AlertCategoryComponent } from "./components/alert-category/alert-category.component";
import { AlertReviewHistoryComponent } from "./components/alert-review-history/alert-review-history.component";
import { AlertEditorComponent } from "./components/alertEditor/alertEditor.component";
import { AlertHistoryComponent } from "./components/alertHistory/alertHistory.component";
import { AlertsManagerComponent } from "./components/alertsManager/alertsManager.component";
import { RecentAlertsComponent } from "./components/recentAlerts/recentAlerts.component";
import { AlertsService } from "./_services/alerts.service";


export class Config {

    static $inject = ["$stateProvider", "routeConfigHelperProvider"];

    constructor(
        private $stateProvider: StateProvider,
        private routeConfigHelperProvider: RouteConfigHelperProvider) {

        $stateProvider.state(AlertsNavigationModule.ParentRoot, {
            abstract: true,
            url: "/alerts",
            redirectTo: AlertsNavigationModule.Default,
            views: { "module-navigation": {} },
            data: { translation: 'Common.Alerts' },
            params: {
                title: "Alerts",
                page: { squash: true, value: null, dynamic: true },
                option: { squash: true, value: null, dynamic: true },
                model: { squash: true, value: null, dynamic: true }
            },
            resolve: {
                authorize: ["authorizationService", (authorization: AuthorizationService) => authorization.authorizeForUser([
                    UserRole.ManageAlerts, UserRole.ManageAlertReviews
                ])]
            }
        });
        $stateProvider.state(AlertsNavigationModule.AlertHistory, {
            url: "/history",
            views: { "content@app": { component: "alertHistory" } },
            data: { translation: 'Common.History' },
            resolve: {
                authorize: ["authorizationService", (authorization: AuthorizationService) => authorization.authorizeForUser([
                    UserRole.ManageAlerts
                ])]
            }
        });
        $stateProvider.state(AlertsNavigationModule.ReviewAlerts, {
            url: "/review",
            views: { "content@app": { component: "alertReviewHistory" } },
            data: { translation: 'Alerts.ActionRequired' },
            resolve: {
                authorize: ["authorizationService", (authorization: AuthorizationService) => authorization.authorizeForUser([
                    UserRole.ManageAlerts, UserRole.ManageAlertReviews
                ])]
            }
        });

        $stateProvider.state(AlertsNavigationModule.Compliance, {
            url: "/compliance",
            views: { "content@app": { component: "alertReviewCompliance" } },
            data: { translation: 'Alerts.Compliance' },
            resolve: {
                authorize: ["authorizationService", (authorization: AuthorizationService) => authorization.authorizeForUser([
                    UserRole.ManageAlerts, UserRole.ManageAlertReviews
                ])]
            }
        });

        $stateProvider.state(AlertsNavigationModule.ManageAlerts, {
            url: "/manage",
            views: { "content@app": { component: "alertsManager" } },
            data: { translation: 'Alerts.ManageAlerts' },
            resolve: {
                authorize: ["authorizationService", (authorization: AuthorizationService) => authorization.authorizeForUser([
                    UserRole.ManageAlerts
                ])]
            }
        });

        this.createAlertView(AlertsNavigationModule.ReviewAlerts);
        this.createAlertView(AlertsNavigationModule.Compliance);
    }
    private createAlertView(parentViewName: string) {
        this.routeConfigHelperProvider.createDetailStateWithBoundParams({
            stateName: `${parentViewName}.view`,
            translation: 'Common.Alerts',
            bindingName: "incidentId",
            component: "incidentDetail",
            breadcrumbNameResolverKey: "incidentName"
        });
    }
}

angular
    .module("app.alerts", [
        "ui.router",
        "ngMaterial"
    ])
    .config(Config)
    .service("alertsService", AlertsService)

    .component("alertsManager", new AlertsManagerComponent())
    .component("alertHistory", new AlertHistoryComponent())
    .component("alertEditor", new AlertEditorComponent())
    .component("recentAlerts", new RecentAlertsComponent())
    .component("recentAlerts", new RecentAlertsComponent())
    .service("alertReviewService", AlertReviewService)
    .component("alertReviewCompliance", new AlertReviewComplianceComponent())
    .component("incidentDetail", new IncidentDetailComponent())
    .directive("alertReviewHistory", downgradeComponent({ component: AlertReviewHistoryComponent }))
    .directive("alertReviewDialog", downgradeComponent({ component: AlertReviewDialogComponent }))
    .directive("resolutionCodeEditor", downgradeComponent({ component: ResolutionCodeEditorComponent }))
    .directive("alertDetail", downgradeComponent({ component: AlertDetailComponent }))
    .directive("geofenceAlertDetail", downgradeComponent({ component: GeofenceAlertDetailComponent }))
    .directive("temperatureAlertDetail", downgradeComponent({ component: TemperatureAlertDetailComponent }))
    .directive("alertCategoryComponent", downgradeComponent({ component: AlertCategoryComponent }))
    .service("axleWeightAlertDetailService", AxleWeightAlertDetailService)
    .service("geofenceAlertDetailService", GeofenceAlertDetailService)
    .service("inputAlertDetailService", InputAlertDetailService)
    .service("powerLossAlertDetailService", PowerLossAlertDetailService)
    .service("tollAlertDetailService", TollAlertDetailService)
    .service("tyreRecordAlertDetailService", TyreRecordAlertDetailService)
    .service("vehicleDiagnosticAlertDetailService", VehicleDiagnosticAlertDetailService)
    .service("videoAlertDetailService", VideoAlertDetailService);
